import {
    CreateTransactionRequestParams,
    CreateTransactionParams,
    ORDER_CONTEXT,
    PaymentFallbackMethodParams,
} from "@payment-client/interfaces/PaymentPublic";
import { MARKETPLACE_BUSINESS_LINE } from "@swiggy-private/payment-types";
import { WALLET_URLS } from "@payment-client/constants/WalletUrls";

export const prepareCreateTxnParams = (params: CreateTransactionRequestParams): CreateTransactionParams => {
    /* eslint-disable @typescript-eslint/naming-convention */
    const txnParams: CreateTransactionParams = {
        amount: params.amount,
        transaction_type: params.transactionType,
        card_bin_number: params.cardBinNumber,
        payment_method: params.paymentMethod,
        payment_method_meta: {},
    };
    txnParams.payment_method_meta = {
        juspay_redirect_url: params.paymentReturnUrl || WALLET_URLS.TXN_RETURN_URL,
    };
    /* eslint-enable @typescript-eslint/naming-convention */

    return txnParams;
};

export const getPaymentFallbackMethodsParamsByBusinessLine = (
    marketplaceBusinessLine: string,
    orderId: string,
    cartKey: string,
): PaymentFallbackMethodParams => {
    /* eslint-disable @typescript-eslint/naming-convention */

    switch (marketplaceBusinessLine) {
        case MARKETPLACE_BUSINESS_LINE.PAY_ON_DELIVERY:
            // For Pay on Delivery, we need to pass the transaction_id to get the payment fallback methods
            // From source of API call we are sending the transaction id in value of order_id
            return {
                context: ORDER_CONTEXT.PAY_ON_DELIVERY,
                order_id: orderId,
                cart_key: cartKey,
            };
        default:
            return {
                order_id: orderId,
            };
    }
    /* eslint-enable @typescript-eslint/naming-convention */
};
